import type { ISosTrackingTrip } from './emergency_tracking';

export enum SosStatus {
  in_progress = 'in_progress',
  resolved = 'resolved',
  canceled = 'canceled',
}

export interface ISosRequestClientInfo {
  user_id: number;
  email: string;
  user_profile: { name: string; last_name: string } | null;
}

export interface ISosRequest {
  id: number;
  service_request_id: number;
  client_user_id: number;
  provider_user_id: number;
  token: string;
  link: string;
  status: SosStatus;
  location_lat: number | null;
  location_lng: number | null;
  location_address: string | null;
  admin_notes: string | null;
  created_at?: string;
  updated_at?: string;
  client?: ISosRequestClientInfo | null;
}

export interface IPaginatedSos {
  total_count: number;
  items: ISosRequest[];
}

export interface ISosEmergencyContact {
  id: number;
  user_id: number;
  name: string;
  phone: string;
  email: string | null;
}

export interface ISosAdminDetail {
  sos: ISosRequest;
  trip: ISosTrackingTrip | null;
  emergency_contacts: ISosEmergencyContact[];
}
